

import '../index.css';

import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { Route, useNavigate, useParams, useSearchParams } from 'react-router-dom';

import { useAuth } from '../../../shared/AuthContext';
import rolePermissions from '../../../shared/rolePermissions';







const Component = ({ model }) => {

  const navigate = useNavigate();

  const { id } = useParams();
  const isEditMode = Boolean(id);
  const [loading, setLoading] = useState(isEditMode);
  const [error, setError] = useState('');

  const { user, loadingSession } = useAuth();
  const canViewContent = rolePermissions.hasPermission(user, 'content.view');
  const canCreateContent = rolePermissions.hasPermission(user, 'content.create');
  const canUpdateContent = rolePermissions.hasPermission(user, 'content.update');


  const [saving, setSaving] = useState(false);
  const canSubmit = isEditMode ? canUpdateContent : canCreateContent;



  const Service = {

    getRecord: ( searchParams ) => {

      const result = {};

      result[ 'status' ] = model.statusConfig.initial.value;

      model.fields.forEach( ( field ) => {
        result[ field.handle ] = searchParams.get(field.handle) || field.initial;
      } );

      return {
        data: result
      };
    },

    getDomain: () => {

      const result = {};
      
      model.domain.forEach( ( field ) => {
        result[ field.handle ] = [];
      } );

      return result;
    },

  };

  const [searchParams] = useSearchParams();

  const [form, setForm] = useState( Service.getRecord( searchParams ) );
  const [domain, setDomain] = useState( Service.getDomain() );

  useEffect(() => {

    const loadRecord = async () => {
      if (!isEditMode) return;

      setLoading(true);
      setError('');
      try {

        const Service = {

          getRecord: async ( id, setForm ) => {

            const result = {};
            
            const Factory = require( '../../../records/modules' ).default;

            const row = await Factory( {
              slug: model.slug
            } ).Data.getRecord( id );

            result.data = row;

            await Promise.all(
              model.fields.map( async ( field ) => {

                const Components = require( '../../../elements' ).default;

                const Component = Components.Data.identity( field.field.value );

                await Component.loadData({
                  handle: field.handle,
                  meta: field.field.meta,
                  record: result.data,
                  result: result
                });
              } )
            );

            setForm( result );
          },
            
          getDomain: async ( id, setDomain ) => {

            const result = {};

            await Promise.all(
              model.domain.map( async ( domain ) => {

                const Components = require( '../../../elements' ).default;

                const Component = Components.Data.domain( domain.domain.value );
                
                await Component.loadDomain({
                  handle: domain.handle,
                  meta: domain.domain.meta,
                  parentId: id,
                  result: result
                });
              } )
            );

            setDomain( result );
          },

        };

        await Service.getRecord(id, setForm);
        await Service.getDomain(id, setDomain);
      } catch (err) {
        setError(`Record Error: ${err?.response?.data?.message || err.message || 'Unable to load Record.'}`);
      } finally {
        setLoading(false);
      }
    };

    loadRecord();
  }, [ model, id, isEditMode ]);





  const [context, setContext] = useState([]);
  const [contextLoading, setContextLoading] = useState([]);

  useEffect(() => {
  
    const loadContext = async () => {
      setContextLoading(true);
      setError('');
      try {

        const result = {};

        await Promise.all(
          model.fields.map( async ( field ) => {

            const Components = require( '../../../elements' ).default;

            const Component = Components.Data.identity( field.field.value );
            
            await Component.loadContext({
              handle: field.handle,
              meta: field.field.meta,
              result: result
            });
          })
        );

        setContext(result);
      } catch (err) {
        setError(`Context Error: ${err?.response?.data?.message || err.message || 'Unable to load Context.'}`);
      } finally {
        setContextLoading(false);
      }
    };

    loadContext();
  }, [ model ]);













  
  const RecordFormSection = require( '../../../components/record/RecordFormSection' ).default;


  function updateField(field, value) {
    setForm((prev) => ({ ...prev, data: { ...prev.data, [field]: value } }));
  }

  function updateDomain(nextDomain) {
    setDomain((prev) => (typeof nextDomain === 'function' ? nextDomain(prev) : nextDomain));
  }

  if (loadingSession) return <p>Checking access...</p>;
  if (!canViewContent) return <p className="error-text">You do not have permission to view this content.</p>;
  if (isEditMode && !canUpdateContent) return <p className="error-text">You do not have permission to update this content.</p>;
  if (!isEditMode && !canCreateContent) return <p className="error-text">You do not have permission to create this content.</p>;

  if (contextLoading) return <p>Loading form...</p>;
  if (loading) return <p>Loading form...</p>;

  const {
    handle,
    details
  } = {
    handle: {
      slug: model.slug,
      handle: model.handle,
      status: model.statusConfig,
      details: model.fields,
    },
    section: model.section,
    slug: model.slug,
    details: {
      items: model.domain
    }
  };

  return (
    <RecordFormSection
      error={error}
      slug={handle.slug}
      id={id}
      header={{
        saving,
        isEditMode,
        canSubmit,
        onSubmit: async function handleSubmit(event) {
          event.preventDefault();
          if (!canSubmit) {
            setError(isEditMode
              ? 'You do not have permission to update this content.'
              : 'You do not have permission to create this content.');
            return;
          }
          setSaving(true);
          setError('');
          try {

            const payload = {};

            ( () => {

              const Components = require( '../../../elements' ).default;

              const Component = Components.Data.identity( model.handle.field.value );

              payload[ model.handle.handle ] = Component.validate( {
                handle: model.handle.handle,
                meta: model.handle.field.meta,
                record: form.data
              } );
            } )();

            ( () => {

              const Components = require( '../../../elements' ).default;

              const Component = Components.Data.identity( 'status' );

              payload[ 'status' ] = Component.validate( {
                handle: 'status',
                meta: {},
                record: form.data
              } );
            } )();

            model.fields.forEach( ( field ) => {

              const Components = require( '../../../elements' ).default;

              const Component = Components.Data.identity( field.field.value );

              payload[ field.handle ] = Component.validate( {
                handle: field.handle,
                meta: field.field.meta,
                record: form.data
              } );
            } );


            const Factory = require( '../../../records/modules' ).default;
          
            const record = id
            ? await Factory( {
              slug: model.slug
            } ).Data.updateRecord( id, payload )
            : await Factory( {
              slug: model.slug
            } ).Data.createRecord( payload );


            await Promise.all( 
              model.domain.map( async ( item ) => {

                const Components = require( '../../../elements' ).default;

                const Component = Components.Data.domain( item.domain.value );
                
                await Component.validate( {
                  handle: item.handle,
                  meta: item.domain.meta,
                  parentId: record.id,
                  domain: domain
                } );
              })
            );


            navigate(`/${handle.slug}/${record.id}`);
          } catch (err) {
            setError(err?.response?.data?.message || err.message || 'Unable to save record.');
          } finally {
            setSaving(false);
          }
        },
      }}
      data={{
        record: form,
        context: context,
        onFieldChange: updateField,
        hasStatus: true,
        initialStatus: handle.status.initial,
        handle: {
          handle: handle.handle.handle,
          label: handle.handle.label,
          meta: handle.handle.field.meta,
          value: handle.handle.field.value,
        },
        details: handle.details.map( ( field ) => ({
          handle: field.handle,
          label: field.label,
          meta: field.field.meta,
          value: field.field.value,
        }) ),
      }}
    >


      {details.items.map((detial, index) => {

        const Components = require( '../../../elements' ).default;

        const Component = Components.Data.domain( detial.domain.value );

        return <Component.Input handle={detial.handle} meta={detial.domain.meta} domain={domain} parentId={id} updateDomain={updateDomain} />;
      })}


    </RecordFormSection>
  );
};




export default Component;